import BaseServicesClient, { PROTECTED_METHODS } from "./BaseServicesClient";
import { RedisClientHelper } from "../helpers/redis-cache-helper";

// PLEASE BE CAREFUL TOUCHING THIS CODE!
// It's very easy to accidentally include the Redis and GCP libraries in the client side bundle
// please use explicit window checks for CSR / SSR splitting
// and make sure you do not reference RedisClientHelper in client code paths
/**
 * A specific implementation of BaseServicesClient that caches responses using Redis.
 * @class CachedServicesClient
 * @extends {BaseServicesClient}
 */
export class CachedServicesClient extends BaseServicesClient {
  async get(path, params, options) {
    // using isSSR here did not work, had to be explicit
    if (typeof window !== "undefined" || options?.bypassCache) {
      // don't run redis in the client bundle or if cache is bypassed (e.g. userId specific content)
      return super.get(path, params, options).then(resp => ({
        text: resp.text.bind(resp),
        json: resp.json.bind(resp),
        status: resp.status,
        headers: resp.headers,
        fromCache: false,
      }));
    } else {
      // grab the url to use as a key. There's some business logic in Base that defines what the URL looks like so lean on that
      const url = super[PROTECTED_METHODS.url](path, params);
      // call .text() here as RedisClientHelper.fetchWithCache expects the result of fetchFromSource (the first argument) to be a string for storing in Redis
      return /*#__PURE__*/ RedisClientHelper.fetchWithCache(
        () => super.get(path, params, options).then(resp => resp.text()),
        url
      );
    }
  }
}
